/** QuickPlan — Assemblages types : groupes d'instances paramétrés, insérés d'un bloc.
 * Les cotes sont des expressions sur les paramètres du gabarit (et la variable de
 * répétition). Chaque instance porte son étape de montage (notice).
 */

const U = 44.45;
const corner = (dx, dy) => [`${dx}+(i%2)*(L-2*${dx})`, `${dy}+floor(i/2)*(P-2*${dy})`];

export default [
  {
    id: 'tpl-cadre40',
    name: 'Cadre rectangulaire 40×40',
    category: 'alu',
    description: 'Cadre vertical (plan XZ) en profilé 40×40 : 2 traverses pleine largeur, 2 montants entre elles, 4 équerres intérieures.',
    params: [
      { key: 'L', label: 'Largeur', default: 1000, min: 200, max: 6000, unit: 'mm' },
      { key: 'H', label: 'Hauteur', default: 600, min: 200, max: 6000, unit: 'mm' },
    ],
    instances: [
      { componentId: 'alu-p40-1x1', name: 'Traverse basse', params: { L: 'L' }, pos: [0, 0, 20], step: 1 },
      { componentId: 'alu-p40-1x1', name: 'Traverse haute', params: { L: 'L' }, pos: [0, 0, 'H-20'], step: 2 },
      { componentId: 'alu-p40-1x1', name: 'Montant', params: { L: 'H-80' }, pos: ['20+i*(L-40)', 0, 40], rot: [0, -90, 0], repeat: { count: 2, var: 'i' }, step: 1 },
      { componentId: 'alu-eq40', name: 'Équerre bas g', pos: [40, 0, 40], step: 1 },
      { componentId: 'alu-eq40', name: 'Équerre bas d', pos: ['L-40', 0, 40], rot: [0, 0, 180], step: 1 },
      { componentId: 'alu-eq40', name: 'Équerre haut g', pos: [40, 0, 'H-40'], rot: [180, 0, 0], step: 2 },
      { componentId: 'alu-eq40', name: 'Équerre haut d', pos: ['L-40', 0, 'H-40'], rot: [0, 180, 0], step: 2 },
    ],
  },
  {
    id: 'tpl-etabli40',
    name: 'Établi / table 40×40',
    category: 'alu',
    description: '4 pieds en profilé 40×40 sur pieds réglables, cadre haut et cadre bas, plateau de 22 mm.',
    params: [
      { key: 'L', label: 'Longueur', default: 1200, min: 400, max: 3000, unit: 'mm' },
      { key: 'P', label: 'Profondeur', default: 800, min: 300, max: 1500, unit: 'mm' },
      { key: 'H', label: 'Hauteur plateau', default: 900, min: 400, max: 1500, unit: 'mm' },
      { key: 'B', label: 'Hauteur cadre bas', default: 200, min: 100, max: 600, unit: 'mm' },
    ],
    instances: [
      { componentId: 'alu-pied', name: 'Pied réglable', pos: [...corner(20, 20), 48], repeat: { count: 4, var: 'i' }, step: 1 },
      { componentId: 'alu-p40-1x1', name: 'Pied', params: { L: 'H-22-48' }, pos: [...corner(20, 20), 48], rot: [0, -90, 0], repeat: { count: 4, var: 'i' }, step: 1 },
      { componentId: 'alu-p40-1x1', name: 'Longeron bas', params: { L: 'L-80' }, pos: [40, '20+i*(P-40)', 'B'], repeat: { count: 2, var: 'i' }, step: 2 },
      { componentId: 'alu-p40-1x1', name: 'Traverse basse', params: { L: 'P-80' }, pos: ['20+i*(L-40)', 40, 'B'], rot: [0, 0, 90], repeat: { count: 2, var: 'i' }, step: 2 },
      { componentId: 'alu-p40-1x1', name: 'Longeron haut', params: { L: 'L-80' }, pos: [40, '20+i*(P-40)', 'H-42'], repeat: { count: 2, var: 'i' }, step: 3 },
      { componentId: 'alu-p40-1x1', name: 'Traverse haute', params: { L: 'P-80' }, pos: ['20+i*(L-40)', 40, 'H-42'], rot: [0, 0, 90], repeat: { count: 2, var: 'i' }, step: 3 },
      { componentId: 'mb-tablette', name: 'Plateau', params: { L: 'L', P: 'P', E: 22 }, pos: [0, 0, 'H-22'], step: 4 },
    ],
  },
  {
    id: 'tpl-caisson',
    name: 'Caisson avec portes',
    category: 'meuble',
    description: 'Caisson sur 4 pieds réglables (hauteur S) : 2 côtés, dessus et dessous entre côtés, fond 3 mm, T tablettes, N portes en applique avec poignées.',
    params: [
      { key: 'L', label: 'Largeur', default: 600, min: 200, max: 1200, unit: 'mm' },
      { key: 'P', label: 'Profondeur', default: 560, min: 200, max: 800, unit: 'mm' },
      { key: 'H', label: 'Hauteur du caisson', default: 720, min: 200, max: 2400, unit: 'mm' },
      { key: 'E', label: 'Épaisseur', default: 19, options: [16, 18, 19, 22], unit: 'mm' },
      { key: 'T', label: 'Tablettes', default: 1, min: 0, max: 8, step: 1 },
      { key: 'N', label: 'Portes', default: 1, options: [0, 1, 2] },
      { key: 'S', label: 'Hauteur des pieds', default: 100, min: 60, max: 200, unit: 'mm' },
    ],
    instances: [
      { componentId: 'mb-pied', name: 'Pied', params: { H: 'S' }, pos: ['50+(i%2)*(L-100)', '50+floor(i/2)*(P-100)', 'S'], repeat: { count: 4, var: 'i' }, step: 1 },
      { componentId: 'mb-cote', name: 'Côté', params: { P: 'P', H: 'H', E: 'E', G: 'i' }, pos: ['i*(L-E)', 0, 'S'], repeat: { count: 2, var: 'i' }, step: 2 },
      { componentId: 'mb-tablette', name: 'Dessous', params: { L: 'L-2*E', P: 'P', E: 'E' }, pos: ['E', 0, 'S'], step: 1 },
      { componentId: 'mb-tablette', name: 'Dessus', params: { L: 'L-2*E', P: 'P', E: 'E' }, pos: ['E', 0, 'S+H-E'], step: 3 },
      { componentId: 'mb-fond', name: 'Fond', params: { L: 'L-2*E', H: 'H-2*E', E: 3 }, pos: ['E', 'P-3', 'S+E'], step: 4 },
      { componentId: 'mb-tablette', name: 'Tablette', params: { L: 'L-2*E-2', P: 'P-23', E: 'E' }, pos: ['E+1', 20, 'S+E+(i+1)*(H-2*E)/(T+1)-E/2'], repeat: { count: 'T', var: 'i' }, step: 5 },
      { key: 'porte', componentId: 'mb-porte', name: 'Porte', params: { L: 'L/max(N,1)-3', H: 'H-3', E: 19, C: 'i*(N-1)' }, pos: ['1.5+i*L/max(N,1)', -19, 'S+1.5'], repeat: { count: 'N', var: 'i' }, step: 6 },
      // Poignée verticale côté opposé aux charnières, ATTACHÉE à sa porte (elle suit l'ouverture).
      { parent: 'porte', componentId: 'mb-poignee', name: 'Poignée', params: { F: 19 }, pos: ['(1-i*(N-1))*(L/max(N,1)-3-40)+i*(N-1)*40', 0, 'H-3-120'], rot: [0, -90, 0], repeat: { count: 'N', var: 'i' }, step: 7 },
    ],
  },
  {
    id: 'tpl-commode',
    name: 'Commode à tiroirs',
    category: 'meuble',
    description: 'Caisson sur pieds avec N tiroirs superposés en applique, chacun avec sa poignée ATTACHÉE (elle suit le tiroir quand on l’ouvre).',
    params: [
      { key: 'L', label: 'Largeur', default: 800, min: 300, max: 1400, unit: 'mm' },
      { key: 'P', label: 'Profondeur', default: 500, min: 350, max: 650, unit: 'mm' },
      { key: 'H', label: 'Hauteur du caisson', default: 800, min: 300, max: 1400, unit: 'mm' },
      { key: 'N', label: 'Tiroirs', default: 4, min: 1, max: 8, step: 1 },
      { key: 'S', label: 'Hauteur des pieds', default: 100, min: 60, max: 200, unit: 'mm' },
    ],
    instances: [
      { componentId: 'mb-pied', name: 'Pied', params: { H: 'S' }, pos: ['50+(i%2)*(L-100)', '50+floor(i/2)*(P-100)', 'S'], repeat: { count: 4, var: 'i' }, step: 1 },
      { componentId: 'mb-cote', name: 'Côté', params: { P: 'P', H: 'H', E: 19, G: 'i' }, pos: ['i*(L-19)', 0, 'S'], repeat: { count: 2, var: 'i' }, step: 2 },
      { componentId: 'mb-tablette', name: 'Dessous', params: { L: 'L-38', P: 'P', E: 19 }, pos: [19, 0, 'S'], step: 1 },
      { componentId: 'mb-tablette', name: 'Dessus', params: { L: 'L-38', P: 'P', E: 19 }, pos: [19, 0, 'S+H-19'], step: 3 },
      { componentId: 'mb-fond', name: 'Fond', params: { L: 'L-38', H: 'H-38', E: 3 }, pos: [19, 'P-3', 'S+19'], step: 4 },
      { key: 'tiroir', componentId: 'mb-tiroir', name: 'Tiroir', params: { L: 'L-3', H: 'H/N-3', P: 'min(550, max(300, floor((P-40)/50)*50))' }, pos: [1.5, 0, 'S+1.5+i*H/N'], repeat: { count: 'N', var: 'i' }, step: 5 },
      { parent: 'tiroir', componentId: 'mb-poignee', name: 'Poignée', params: { F: 19 }, pos: ['(L-3)/2', -19, '(H/N-3)/2'], repeat: { count: 'N', var: 'i' }, step: 6 },
    ],
  },
  {
    id: 'tpl-etagere',
    name: 'Étagère',
    category: 'meuble',
    description: 'Étagère ouverte : 2 côtés, N tablettes réparties (la première au sol, la dernière en haut), fond 3 mm.',
    params: [
      { key: 'L', label: 'Largeur', default: 800, min: 200, max: 2000, unit: 'mm' },
      { key: 'P', label: 'Profondeur', default: 300, min: 150, max: 800, unit: 'mm' },
      { key: 'H', label: 'Hauteur', default: 1800, min: 300, max: 2600, unit: 'mm' },
      { key: 'E', label: 'Épaisseur', default: 19, options: [16, 18, 19, 22], unit: 'mm' },
      { key: 'N', label: 'Tablettes', default: 5, min: 2, max: 12, step: 1 },
    ],
    instances: [
      { componentId: 'mb-cote', name: 'Côté', params: { P: 'P', H: 'H', E: 'E', G: 'i' }, pos: ['i*(L-E)', 0, 0], repeat: { count: 2, var: 'i' }, step: 1 },
      { componentId: 'mb-tablette', name: 'Tablette', params: { L: 'L-2*E', P: 'P', E: 'E' }, pos: ['E', 0, 'i*(H-E)/max(N-1,1)'], repeat: { count: 'N', var: 'i' }, step: 2 },
      { componentId: 'mb-fond', name: 'Fond', params: { L: 'L', H: 'H', E: 3 }, pos: [0, 'P', 0], step: 3 },
    ],
  },
  {
    id: 'tpl-baie-reseau',
    name: 'Baie réseau équipée',
    category: 'rack',
    description: 'Baie 19" avec, en partant du haut, N groupes brassage 24 / passe-câbles / switch 48, puis un onduleur 2U en bas et un PDU au-dessus.',
    params: [
      { key: 'U', label: 'Hauteur utile', default: 42, min: 12, max: 52, unit: 'U' },
      { key: 'W', label: 'Largeur', default: 800, options: [600, 800], unit: 'mm' },
      { key: 'P', label: 'Profondeur', default: 800, options: [600, 800, 1000, 1200], unit: 'mm' },
      { key: 'N', label: 'Groupes de brassage', default: 2, min: 0, max: 8, step: 1 },
    ],
    instances: [
      { key: 'baie', componentId: 'rk-baie', name: 'Baie', params: { U: 'U', W: 'W', P: 'P', F: 70, C: 1 }, pos: [0, 0, 0], step: 1 },
      { parent: 'baie', componentId: 'rk-porte', name: 'Porte vitrée', params: { U: 'U', W: 'W', C: 1 }, pos: [0, -20, 75], step: 5 },
      { componentId: 'rk-onduleur', name: 'Onduleur', params: { N: 2, P: 600 }, pos: ['(W-482.6)/2', 70, 75], step: 2 },
      { componentId: 'rk-pdu', name: 'PDU', pos: ['(W-482.6)/2', 70, `75+2*${U}`], step: 2 },
      { componentId: 'rk-brassage24', name: 'Brassage', pos: ['(W-482.6)/2', 70, `75+(U-1-3*i)*${U}`], repeat: { count: 'N', var: 'i' }, step: 3 },
      { componentId: 'rk-passe-cables', name: 'Passe-câbles', pos: ['(W-482.6)/2', 70, `75+(U-2-3*i)*${U}`], repeat: { count: 'N', var: 'i' }, step: 3 },
      { componentId: 'rk-switch48', name: 'Switch', pos: ['(W-482.6)/2', 70, `75+(U-3-3*i)*${U}`], repeat: { count: 'N', var: 'i' }, step: 4 },
    ],
  },
];
